import React from 'react';
import Form from 'next/form'

import styles from './form.module.css';

export type FormProps = React.HTMLAttributes<HTMLFormElement> & {
  children?: React.ReactNode,
  action?: string
}

export const FormWrapper = ({action = '/', children, ...props}: FormProps) => {

  return (
    <Form action={action} prefetch={false} className={styles.form} {...props}>
      {children}
    </Form>
  )
};


export const SimpleForm = ({children, ...props}: FormProps) => {

  return (
    <form className={styles.form} {...props}>
      {children}
    </form>
  )
};

